import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { useState, useEffect } from 'react';
import { subMonths, format } from 'date-fns';
import { getMonthlyDoctorsManuallyAddedPatients } from '../../../utils/functions';

const COLORS = ["#783BFF", "#7FB1BA"];

export default function MonthlyAddedPatients({ monthlyAddedPatients, setMonthlyAddedPatients, openMonthlyPatientsModal, setOpenMonthlyPatientsModal, doctor_name, doctor_id, month, setMonth }) {
  const [pieData, setPieData] = useState(null);
  const [total, setTotal] = useState(null);
  const [displayDate, setDisplayDate] = useState(format(new Date(), 'MMMM yyyy'));
  const [cache, setCache] = useState({});

  useEffect(() => {
    if (cache[month]) {
      // Use cached data if available
      const cachedData = cache[month];
      setTotal(cachedData.totalPatients);
      setPieData([
        { name: "Total Patients", value: cachedData.totalPatients },
        { name: "Added Patients", value: cachedData.addedPatients }
      ]);
    } else {
      // Fetch data if not cached
      updateMonthlyAddedPatients(doctor_id, month);
    }
  }, [month, doctor_id])

  useEffect(() => {
    const newDisplayDate = subMonths(new Date(), month + 1);
    setDisplayDate(format(newDisplayDate, 'MMMM yyyy'));
  }, [month])

  const customLegend = (value, entry) => {
    const { value: chartVal } = entry.payload;

    return `${value}: ${chartVal}`;
  }

  const monthBackward = () => {
    setMonth(prevMonth => prevMonth + 1);
  }

  const monthForward = () => {
    setMonth(prevMonth => prevMonth - 1);
  }

  const updateMonthlyAddedPatients = async (doctor_id, month) => {
    const data = await getMonthlyDoctorsManuallyAddedPatients(doctor_id, month);
    setMonthlyAddedPatients(data);
    setCache(prevCache => ({
      ...prevCache,
      [month]: data
    }));
    setTotal(data.totalPatients);
    setPieData([
      { name: "Total Patients", value: data.totalPatients },
      { name: "Added Patients", value: data.addedPatients }
    ]);
  };

  const closeMonthlyPatientsModal = () => {
    setOpenMonthlyPatientsModal(false);
  }

  const generateFormattedMonth = (month) => {
    return format(subMonths(new Date(), parseInt(month) + 1), "MMMM yyyy");
  }

  return (
    <div className='fixed left-[28%] top-[28%] w-[50%] flex flex-col items-center justify-center bg-light-purple p-4 rounded-md shadow-md z-10'>
      <h2 className='text-[26px] mb-4'>Monthly Patient Additions for {doctor_name}</h2>
      <h3 className='text-[22px] mb-[1rem]'>{displayDate}</h3>
      <button className='absolute right-[20px] top-[10px] hover:text-ktx-navy font-bold text-[26px]' onClick={closeMonthlyPatientsModal}>×</button>
      <button className="text-ktx-purple text-[30px] font-semibold hover:text-ktx-navy  absolute top-[7.7rem] z-20 right-2" disabled={month === -1} onClick={monthForward}>{">"}</button>
      <button className="text-ktx-purple text-[30px] font-semibold hover:text-ktx-navy  absolute top-[7.7rem] z-20 left-2" onClick={monthBackward}>{"<"}</button>

      {Object.keys(cache).length > 0 &&
        <select className="w-[50%] mx-auto rounded-md mb-4" value={month} onChange={(e) => setMonth(parseInt(e.target.value))}>
          {Object.keys(cache).sort((a,b) => a - b).map((el, i) => (
            <option key={i} value={el}>Month of {generateFormattedMonth(el)}</option>
          ))}
        </select>
      }

      {total !== 0 ? (<div className='relative w-full h-full z-10'>
        <ResponsiveContainer width={"96%"} height={400}>
          <PieChart>
            <Pie
              data={pieData}
              cx={"42%"}
              cy={"40%"}
              labelLine={false}
              outerRadius={160}
              fill="#8884d8"
              dataKey="value"
            >
              {pieData !== null && pieData.map((_, i) => (
                <Cell key={`cell-${i}`} fill={COLORS[i % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend layout="vertical" align="right" iconType="circle" iconSize={10} verticalAlign='middle' formatter={customLegend} />
          </PieChart>
        </ResponsiveContainer>
      </div>) : <div>No patients this month</div>}

    </div>
  )
}